import type { AppState } from '../types'

export const getNews = (state: AppState) => state.news
